import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/mobileapp.css";
// import logo from "../assets/logotvk.png"
import centerImg from "../assets/centerimg.png"; // 🔁 change filename
import logo1 from "../assets/logo.png"; // 🔁 change path if needed
import {
  FaUsers,
  FaVoteYea,
  FaNewspaper,
  FaPhone,
  FaMapMarkerAlt,
  FaImages,
  FaCommentDots,
  FaStar,
  FaRegStar,
  FaBookOpen
} from "react-icons/fa";

export default function MobileApp() {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  // 🔁 comments data
  const comments = [
    {
      id: 1,
      name: "Subash",
      text: "TVK எங்கள் பகுதியில் உண்மையான மாற்றத்தை கொண்டு வருகிறது!",
      rating: 5,
    },
    {
      id: 2,
      name: "Satheesh",
      text: "மிகவும் செயலில் உள்ள உறுப்பினர்கள் மற்றும் சிறந்த தலைமையகம்.",
      rating: 4,
    },
    {
      id: 3,
      name: "Abishek",
      text: "TVK திர்பரப்பு ஆதரிப்பதில் பெருமை கொள்கிறேன்.",
      rating: 4,
    },
  ];

  // 🔁 auto slider
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % comments.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [comments.length]);

  // ✅ cubes with navigation paths
  const cubes = [
    { id: 1, icon: <FaUsers />, label: "உறுப்பினர்கள்", path: "/members" },
    { id: 2, icon: <FaBookOpen />, label: "ஆவணங்கள்",  path: "/videos" },
    { id: 3, icon: <FaVoteYea />, label: "வாக்கு",  path: "/mobilecharts" },
    { id: 4, icon: <FaNewspaper />, label: "செய்திகள்",  maintenance: true },
    { id: 5, icon: <FaPhone />, label: "தொடர்பு கொள்ள",  path: "/mobilecontact" },
    { id: 6, icon: <FaMapMarkerAlt />, label: "இருப்பிடம்",  path: "/location" },
    { id: 7, icon: <FaImages />, label: "புகைப்படங்கள்",  path: "/mobilegallery" },
    { id: 8, icon: <FaCommentDots />, label: "கருத்து",   path: "/send-noti"  },
  ];

  // ⭐ star renderer
  const renderStars = (rating) => {
    return (
      <div className="stars">
        {[...Array(5)].map((_, i) =>
          i < rating ? <FaStar key={i} /> : <FaRegStar key={i} />
        )}
      </div>
    );
  };

  return (
    <div className="mobile-container">
      {/* HEADER */}
<div className="mobile-header">
  <img src={logo1} alt="TVK Logo" className="mobile-logo" />
</div>
      {/* GRID */}
        <div className="cube-grid">
        {cubes.map((item) => (
            <div
            key={item.id}
            className={`cube ${item.maintenance ? "cube-disabled" : ""}`}
            onClick={() => {
                if (!item.maintenance && item.path) {
                navigate(item.path);
                }
            }}
            >
            <div className="cube-icon">{item.icon}</div>
            <p>{item.label}</p>

            {/* 🔧 maintenance tooltip */}
            {item.maintenance && (
                <span className="maintenance-tooltip">
                🚧 பராமரிப்பில் உள்ளது
                </span>
            )}
            </div>
        ))}
        </div>

{/* 🔥 CENTER IMAGE */}
<div className="center-image-wrapper">
  <img src={centerImg} alt="TVK Banner" className="center-image" />
</div>

{/* COMMENTS */}
      {/* COMMENTS */}
      <div className="comment-section">
        <h3>உறுப்பினர் மதிப்புரைகள்</h3>

        <div className="comment-card">
          <h4>{comments[index].name}</h4>
          <p>"{comments[index].text}"</p>
          {renderStars(comments[index].rating)}
        </div>
      </div>
    </div>
  );
}